<template>
	<!-- Pricing Section -->
	<div class="py-5">
		<div class="container">
			<div class="text-center mb-5">
				<h2 class="fw-bold mb-2">Plan Details</h2>
				<!-- <p class="text-muted mx-auto" style="max-width: 600px">
						Select the perfect plan that fits your nutritional tracking needs
						and budget.
					</p> -->
			</div>

			<div class="row g-4 justify-content-center">
				<!-- Basic Plan Card -->
				<div class="col-md-6">
					<div class="card shadow-sm h-100">
						<div class="card-header bg-white py-4 text-center border-bottom">
							<h3 class="fw-bold mb-3">Basic</h3>
							<!-- <div class="mb-0">
									<span class="display-6 fw-bold">$0</span>
									<span class="text-muted">/month</span>
								</div> -->
						</div>
						<div class="card-body">
							<ul class="list-unstyled">
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-x-lg text-muted me-2"></i>
									<span class="text-muted">Contains advertisements</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Logging of Meals with Camera</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Import Pictures of Past Meals to Log New Meals</span>
								</li>
								<!-- <li class="mb-3 d-flex align-items-center">
											<i class="bi bi-check-lg text-success me-2"></i>
											<span
												>ID Meal Type (Breakfast, Lunch, Dinner, Dessert,
												Snack)</span
											>
										</li> -->
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span
										>Track Cook Type (Home-cooked, Store-bought,
										Restaurant)</span
									>
								</li>
								<!-- <li class="mb-3 d-flex align-items-center">
											<i class="bi bi-check-lg text-success me-2"></i>
											<span>Automatically Log Time of Each Meal Course</span>
										</li> -->
								<!-- <li class="mb-3 d-flex align-items-center">
											<i class="bi bi-check-lg text-success me-2"></i>
											<span
												>Automatically Identify Contents of Meal Courses</span
											>
										</li> -->
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Free-form Edit of Mis-identified Meal Components</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span
										>Automatically Summarize Nutritional Totals of Each Meal
										Course</span
									>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Display Daily Nutritional Totals</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Edit Category Tags and Date/Time of Meals</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span
										>Automatically Identify Possible Allergens Contained in
										Meal</span
									>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span
										>Display Allergy Warnings When displaying Captured Meal
										Course</span
									>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span
										>Point Rating of Meal Courses (considers your identified
										allergies)</span
									>
								</li>
								<!-- <li class="mb-3 d-flex align-items-center">
											<i class="bi bi-check-lg text-success me-2"></i>
											<span
												>Auto Time of Day Classification of Meal Default</span
											>
										</li> -->
								<!-- <li class="mb-3 d-flex align-items-center">
											<i class="bi bi-check-lg text-success me-2"></i>
											<span
												>Grouping of Meal Courses into Meal (with average point
												rating)</span
											>
										</li> -->

								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Calendar View Tracking of Restaurant Meals</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Daily Calorie by Month Report</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Daily Meal Rating per Meal Type by Month Report</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span
										>Calendar View Tracking of Daily Nutrition and Meals</span
									>
								</li>
								<!-- <li class="mb-3 d-flex align-items-center">
											<i class="bi bi-check-lg text-success me-2"></i>
											<span
												>Search for Meals at a Specific Restaurant or Meal
												Component</span
											>
										</li> -->
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span
										>Weekly Nutrition Performance Report Email with
										Suggestions</span
									>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Pictorial History of Meals</span>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<!-- Plus Plan Card -->
				<div class="col-md-6">
					<div class="card shadow h-100 border-warning position-relative">
						<div
							class="position-absolute top-0 end-0 bg-warning text-white px-3 py-1 small fw-semibold rounded-bottom-start">
							POPULAR
						</div>
						<div
							class="card-header text-white text-center py-4 border-bottom bg-warning position-relative">
							<span
								:class="[
									'pricing-badge',
									plusPricing && plusPricing.color
										? `bg-${plusPricing.color}`
										: '',
									'text-white',
								]">
								<i class="bi bi-star-fill me-1"></i
								>{{ plusPricing?.badge || "" }}
							</span>
							<h3 class="fw-bold mb-3">Plus</h3>
							<div class="mb-0 d-flex flex-column align-items-center gap-1">
								<span class="pricing-amount"
									>{{ plusPricing?.monthly?.price || ""
									}}<span class="pricing-period">/mo</span></span
								>
								<span class="text-muted">or</span>
								<span class="pricing-amount"
									>{{ plusPricing?.yearly?.price || ""
									}}<span class="pricing-period">/yr</span></span
								>
							</div>
							<div class="pricing-note">
								{{ plusPricing?.note || "" }}
							</div>
						</div>
						<div class="card-body">
							<ul class="list-unstyled">
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>No Ads</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Everything in Basic</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span
										>Quick Entry of Meal Course by Duplicating Previous Meal
										Course</span
									>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Capture and Consider Meal Leftovers</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span
										>Provide Allergy-free Alternative to Captured Meal (with
										Equipment, Ingredients, Instructions)</span
									>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span
										>Can generate a daily Meal Plan for a Week (based on Likes,
										Dislikes, Allergies, Restrictions, Goals, etc.)</span
									>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Recipe for Meals in Meal Plan</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Track Weight Measurements</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Track Blood Sugar</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Grocery List</span>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span
										>Notification for Time to Measure Blood Sugar After
										Meal</span
									>
								</li>
								<li class="mb-3 d-flex align-items-center">
									<i class="bi bi-check-lg text-success me-2"></i>
									<span>Add Member to Profile</span>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<!-- Pro Plan -->
				<!-- <div class="col-md-4">
						<div class="card shadow-sm h-100">
							<div class="card-header bg-white py-4 text-center border-bottom">
								<h3 class="fw-bold mb-3">Pro</h3>
								<div class="mb-0">
									<span class="display-6 fw-bold">$9.99</span>
									<span class="text-muted">/month</span>
								</div>
							</div>
							<div class="card-body">
								<ul class="list-unstyled">
									<li class="mb-3 d-flex align-items-center">
										<i class="bi bi-check-lg text-success me-2"></i>
										<span>All Premium features</span>
									</li>
									<li class="mb-3 d-flex align-items-center">
										<i class="bi bi-check-lg text-success me-2"></i>
										<span>Meal planning tools</span>
									</li>
									<li class="mb-3 d-flex align-items-center">
										<i class="bi bi-check-lg text-success me-2"></i>
										<span>Personalized diet plans</span>
									</li>
									<li class="mb-3 d-flex align-items-center">
										<i class="bi bi-check-lg text-success me-2"></i>
										<span>Direct nutritionist access</span>
									</li>
									<li class="mb-3 d-flex align-items-center">
										<i class="bi bi-check-lg text-success me-2"></i>
										<span>Family account sharing</span>
									</li>
								</ul>
								<button class="btn btn-primary w-100 mt-3">Get Pro</button>
							</div>
						</div> 
					</div>-->
			</div>
		</div>
	</div>
</template>

<script setup>
	import { computed } from "vue"
	import { Capacitor } from "@capacitor/core"

	const plusPricing = computed(() => {
		console.log("SAdas")
		if (Capacitor.isNativePlatform()) {
			return {
				monthly: { price: "$5.99", label: "per month" },
				yearly: { price: "$59.99", label: "per year" },
				badge: "Amazing",
				color: "primary",
				note: "Best value on the app!",
			}
		} else {
			return {
				monthly: { price: "$4.99", label: "per month" },
				yearly: { price: "$49.99", label: "per year" },
				badge: "Web Special",
				color: "success",
				note: "Save more on the web!",
			}
		}
	})
</script>

<style scoped>
	.pricing-badge {
		position: absolute;
		top: 0.5rem;
		left: 0.5rem;
		z-index: 2;
		font-size: 0.95rem;
		padding: 0.3rem 0.8rem;
		border-radius: 1rem;
		font-weight: bold;
	}
	.pricing-note {
		font-size: 0.95rem;
		color: #555;
		margin-top: 0.5rem;
		font-style: italic;
	}
	.pricing-amount {
		font-size: 2.2rem;
		font-weight: bold;
		letter-spacing: -1px;
	}
	.pricing-period {
		font-size: 1.1rem;
		color: #666;
		margin-left: 0.3rem;
	}
</style>
